const initialState = {
  list: {},
  brands: {},
}

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS': return { ...state, list: action.products }
    case 'SET_BRANDS': return { ...state, brands: action.brands }
    default: return state
  }
}

export default productsReducer